(function($, Drupal) {
  'use strict';

  Drupal.behaviors.publications = {
    attach: function(context, settings) {
      // Variables broken up for readability
      // content variables
      let $site_header,
          $pub_credits,
          $page_header,
          $pub_header,
          $pub_share,
          $pub_table_contents,
          $pub_content_headings,
          $citations,
          $citation_markup,
          $related_posts;

      // Set global variables
      $('.field--name-body').first().attr('id', 'pub-body');
      $site_header = $('#site-header');
      $page_header = $('#page-header');
      $pub_credits = $('.js-toggle-creds');
      $pub_header = $('#js-pub-header');
      $pub_share = $('#js-pub-share');
      $pub_table_contents = $('#publication-content-top');
      $pub_content_headings = $('#publication-content').find('h2, h3');
      $citations = $('#publication-content .see-footnote');
      $citation_markup = $('#publication-content .footnotes li');
      $related_posts = $('#js-pub-related');

      // Function checks body content and creates a table of contents pulling from the h2s and h3s found in the content
      function pubTableContents() {
        let $table_markup = '';
        $pub_content_headings.once('add-publication-header').each(function(h) {
          // Add back to top links
          let $back_to_top = '<a class="back-to-top" href="#publication-content-top"><span>TOP</span><i class="fa-solid fa-arrow-up"></i></a>';
          $(this).wrap('<div class="pub-content-heading" id="heading-' + h + '"></div>');
          $('#heading-' + h).append($back_to_top);

          // Populate table of contents
          if (h === 0) {
            $pub_table_contents.append('<ul id="pub-table-list"></ul>');
          }

          let $heading_text = $(this).text();

          if ($(this).find('.see-footnote').length !== 0) {
            let $heading_text_clone = $(this).clone();
            $heading_text_clone.find('.see-footnote').remove();
            // $heading_text = $(this).clone();
            $heading_text = $heading_text_clone.text();
          }

          if ($(this).is('h2')) {
            if ($pub_content_headings.eq(h + 1) && $pub_content_headings.eq(h + 1).is('h2')) {
              $table_markup = $table_markup + '<li><a href="#heading-' + h + '">' + $heading_text + '</a></li>';
            }
            else if ($pub_content_headings.eq(h + 1) && $pub_content_headings.eq(h + 1).is('h3')) {
              $table_markup = $table_markup + '<li><a href="#heading-' + h + '">' + $heading_text + '</a><ul>';
            }
            else {
              $table_markup = $table_markup + '<li><a href="#heading-' + h + '">' + $heading_text + '</a></li>';
            }
          }

          if ($(this).is('h3')) {
            $table_markup = $table_markup + '<li><a href="#heading-' + h + '">' + $heading_text + '</a></li>';

            if ($pub_content_headings.eq(h + 1) && $pub_content_headings.eq(h + 1).is('h2')) {
              $table_markup = $table_markup + '</li></ul>';
            }
          }

          // Close list
          if (h === $pub_content_headings.length) {
            $table_markup = $table_markup + '</ul>';
          }
        });

        $('#pub-table-list').append($table_markup);

        if ($pub_content_headings.length > 0) {
          $('#js-pub-table-wrap').show();
        }
        if ($('.no-header').length !== 0 && $pub_content_headings.length === 0) {
          $('#publication-content').addClass('no-header-adjustement');
        }
      }

      // Receives text as an argument and returns the test with any URL within wrapped in a tags
      function wrapUrl(text) {
        // Create your regex pattern for urls
        let urlPattern = /\b((?:[a-z][\w-]+:(?:\/{1,3}|[a-z0-9%])|www\d{0,3}[.]|[a-z0-9.]+[.][a-z]{2,4}\/)(?:[^\s()<>]+|\(([^\s()<>]+|(\([^\s()<>]+\)))*\))+(?:\(([^\s()<>]+|(\([^\s()<>]+\)))*\)|[^`!()\]{};:'".,<>?«»“”‘’]))/ig;

        // Check string for any url patterns and wrap them in anchor tags
        let result = text.replace(urlPattern, function(url) {
          let $url = url.trim();
          let $period = '';

          if ($url[$url.length - 1] === '.') {
            $url = $url.slice(0, -1);
            $period = '.';
          }

          // check if url is wrapped with a
          if ($url.indexOf('<a') === -1) {
            return $url + $period.trim();
          }

          return '<a href="' + $url + '">' + $url + '</a>' + $period.trim();
        });


        return result;
      }

      // Cite variables
      // let $foot_note_links,
      // $citation_group,
      let $cite_id,
          $cite_val,
          $cite_href,
          $cite_trigger_mobile,
          $cite_content_mobile,
          $cite_list_item,
          $cite_class,
          $cite_read_more;

      //Receives a cite link and returns a list element to be added to the citation sidebar
      function citeItem($cite_item, index) {
        // Grab varariables from received link element
        $cite_id = $cite_item.attr('id');
        $cite_href = $cite_item.attr('href').replace('#', '');
        $cite_val = $cite_item.text();
        $cite_class = $cite_item.attr('class');
        // Create citation li element
        // If citation is longer the 75 characters add readmore class for hide/show toggle
        if ($cite_item.attr('title').length > 75) {
          $cite_read_more = '<button class="js-read-more-toggle"><span class="more">Show</span><span class="less">Hide</span></button>';
          $cite_list_item = '<li><a class="see-cite ' + $cite_class + '" id="' + $cite_href + '" href="#' + $cite_id + '">' + $cite_val + '</a><div class="cite-content read-more">' + wrapUrl($citation_markup[index].innerHTML) + $cite_read_more + '</div></li>';
        }
        else {
          $cite_list_item = '<li><a class="see-cite ' + $cite_class + '" id="' + $cite_href + '" href="#' + $cite_id + '">' + $cite_val + '</a><div class="cite-content">' + wrapUrl($citation_markup[index].innerHTML) + '</div></li>';
        }
        // Return completed li element
        return $cite_list_item;
      }

      // Smooth scroll function for any anchor links generated within the content
      function smoothAnchor() {
        $(document).on('click', 'a[href^="#"]', function(event) {
          event.preventDefault();
          let target = this.hash;
          let $target = $(target);
          let $extra_height = 0;
          if ($('.expanded').length !== 0) {
            $extra_height = $('.expanded').outerHeight(true);
          }
          $('html, body').animate({
            scrollTop: $target.offset().top - 270 - $extra_height
          }, 300);
          $('.cite-content').removeClass('hazed');
          window.location.hash = target;
          $('.read-more').removeClass('expanded');
          $('.active-cite').removeClass('active-cite');
          if ($(this).hasClass('see-footnote')) {
            $(target).addClass('active-cite');
            $(target).siblings('.read-more').find('.js-read-more-toggle').trigger('click');
            $(target).siblings('.read-more').parent().find('.see-cite').addClass('active-cite');
          }
        });
      }

      // expanded and collapse function for citations found in the sidebar
      function addReadmore() {
        $('.js-read-more-toggle').off().on('click', function() {
          $('.js-read-more-toggle').not($(this)).parent().removeClass('expanded');
          $(this).parent().toggleClass('expanded');

          if ($(this).parent().hasClass('expanded')) {
            $('.cite-content').addClass('hazed');
          }
          else {
            $('.cite-content').removeClass('hazed');
          }
        });
      }


      // Toggle for inline citations on mobile devices
      function inlineCiteToggle() {
        $('.js-open-cite').off().on('click', function() {
          $('.js-open-cite').not($(this)).removeClass('show-cite');
          $(this).toggleClass('show-cite');
        });

        $('.js-hide-inline-cite').off().on('click', function() {
          $('.js-open-cite').removeClass('show-cite');
        });
      }

      // Spacing variables
      let $content_total_height,
          $margin_top,
          $block_height_total;

      // Calculates the spacing of citations, lining up sidebar citation with its place in the content if possible
      function spaceCitations($citation_items) {
        $block_height_total = 0;
        $content_total_height = $('#pub-body').offset().top;

        $citation_items.each(function(index) {
          // find the coinciding sidebar item and space
          let $current_li = $('#js-citations-list').find('li').eq(index);
          $current_li.attr('style', '');

          // Grab footnotes offset from top of content
          $margin_top = $(this).offset().top - $content_total_height - $block_height_total;

          // minor tweak to make items uniform if alignment to citation in content is not possible
          if ($margin_top > 18) {
            $current_li.css('margin-top', $margin_top - 2);
          }

          $block_height_total = $block_height_total + $current_li.outerHeight(true);
        });
        addReadmore();
        inlineCiteToggle();
      }

      // checks if received item is in viewport
      function isInViewport($element) {
        let elementTop = $element.offset().top;
        let elementBottom = elementTop + $element.outerHeight();
        let viewportTop = $(window).scrollTop();
        let viewportBottom = viewportTop + $(window).height();
        return elementBottom > viewportTop && elementTop < viewportBottom;
      }

      // Adds dynamic sticky scroll to share sidebar element
      function stickyShare() {
        if (!isInViewport($related_posts)) {
          if ($(window).width() > 768) {
            let $scroll_top, $header_offset, $distance, $share_spacer;
            $scroll_top = $(window).scrollTop();
            $header_offset = $pub_header.offset().top;
            $distance = ($header_offset - $scroll_top);
            $share_spacer = $scroll_top - $page_header.height() + 'px';

            if ($distance <= $site_header.height()) {
              $pub_share.css('top', $share_spacer);
            }
            else {
              $pub_share.attr('style', '');
            }
          }
        }
      }

      // Remove hash from URL
      function removeHash() {
        history.pushState('', document.title, window.location.pathname + window.location.search);
      }

      if ($('.page-node-type-publication').length !== 0) {
        pubTableContents();

        // Warning Duplicate IDs
        $('#pub-body [id]').once('check-ids').each(function() {
          let ids = $('[id="' + this.id + '"]');
          if (ids.length > 1 && ids[0] === this) {
            $('#' + this.id).each(function(index) {
              $('#' + this.id).addClass('duplicate');
              $('#' + this.id).attr('id', this.id + index);
            });
          }
        });

        // Build citation items, attaching toggle functionality
        $citations.each(function(index) {
          if ($citation_markup[index] !== undefined && $citation_markup[index].innerHTML !== undefined) {
            $cite_id = $(this).attr('id');
            $cite_val = $(this).text();
            $cite_trigger_mobile = '<button class="js-open-cite" id="cite-content-' + $cite_id + '">' + $cite_val + '</button>';
            $cite_content_mobile = '<div class="cite-content-mobile"><span>' + $cite_val + '</span><p>' + wrapUrl($citation_markup[index].innerHTML) + '<button class="js-hide-inline-cite">Hide</button></p></div>';
            $(this).once('append-cite-button-' + index).after($cite_trigger_mobile);
            $('#cite-content-' + $cite_id).once('append-cite-' + index).after($cite_content_mobile);
            $('#js-citations-list').once('append-item-' + index).append(citeItem($(this), index));
          }
        });


        let $table_block_toggle = $('.js-toggle-table-contents');
        if ($table_block_toggle.length !== 0) {
          $table_block_toggle.once('toggles-table-add').on('click', function() {
            $(this).toggleClass('expanded');
            $(this).siblings('ul').slideToggle(300);
          });
        }

        // wiat for page load before creating citation sidebar
        setTimeout(function() {
          spaceCitations($citations);
        }, 100);

        $(window).resize(function() {
          if ($(window).width() > 768) {
            spaceCitations($citations);
          }
          else {
            $pub_share.attr('style', '');
            $table_block_toggle.siblings('ul').attr('style', '');
          }
        });

        $(window).scroll(function() {
          if ($(window).width() > 768) {
            stickyShare();
          }
        });

        $(document).on('click', function(event) {
          let $target = $(event.target);
          if (!$target.is('a') && !$target.is('button')) {
            removeHash();
            $('.active-cite').removeClass('active-cite');
          }
        });

        // Additional function calls
        smoothAnchor();
        stickyShare();
        $('.footnotes').remove();
        $('.footnote-label').remove();
      }

      $pub_credits.off().on('click', function() {
        $('.js-toggle-creds').not($(this)).removeClass('show-credit');
        $(this).toggleClass('show-credit');
      });
    }
  };
})(jQuery, Drupal);
